module.exports = __webpack_public_path__ + "img/notStarted.9f621ab6.svg";